import { render, staticRenderFns } from "./GanttWidget.vue?vue&type=template&id=443c2f8c&scoped=true"
import script from "./GanttWidget.vue?vue&type=script&lang=js"
export * from "./GanttWidget.vue?vue&type=script&lang=js"
import style0 from "./GanttWidget.vue?vue&type=style&index=0&id=443c2f8c&prod&scoped=true&lang=scss"
import style1 from "./GanttWidget.vue?vue&type=style&index=1&id=443c2f8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443c2f8c",
  null
  
)

export default component.exports